import classNames from "classnames/bind";
import { useEffect, useRef } from 'react';
import FeatureEventsSlide from "./Slide";
import { FeatureEventsFragment } from "@graphqlTypes";
import { CarouselPagination, Container } from "@components";
import { Splide, SplideTrack, SplideSlide } from "react-splide-ts";

import styles from './FeatureEvents.module.scss';
const cx = classNames.bind(styles);

export default function FeatureEventsCarousel(props: FeatureEventsFragment) {
  const { events, cta } = props;
  const rootEl = useRef<HTMLDivElement>(null);

  // Override accessibility attributes
  useEffect(() => {
    if (!rootEl.current) return;
    const lists = rootEl.current.querySelectorAll('.splide__list');
    lists.forEach(list => {
      list.setAttribute('role', 'list');
    });
    const slides = rootEl.current.querySelectorAll('.splide__slide');
    slides.forEach(slide => {
      slide.setAttribute('role', 'listitem');
    });
  }, []);

  return (
    <div ref={rootEl}>
      <Splide
        hasTrack={false}
        options={{
          type: 'slide',
          arrows: true,
          pagination: true,
          speed: 500,
          flickMaxPages: 1,
          flickPower: 250,
          updateOnMove: true,
          perPage: 1,
          perMove: 1,
          fixedWidth: "90%",
          gap: '3rem',
          padding: {
            left: '5rem',
            right: '5rem',
          },
          breakpoints: {
            1025: {
              gap: '3rem',
              padding: {
                left: '4rem',
                right: '4rem',
              },
              arrows: false
            },
            769: {
              perPage: 1,
              perMove: 1,
              fixedWidth: "100%",
              gap: '2rem',
              padding: {
                left: '2rem',
                right: '2rem',
              },
            },
          }
        }}
      >
        <SplideTrack>
          {events.nodes.map((event, index) => (
            <SplideSlide key={index} aria-label={(event as any).title}>
              <FeatureEventsSlide {...event} />
            </SplideSlide>
          ))}
        </SplideTrack>
        <Container className={cx("carousel-pagination")}>
          <CarouselPagination cta={cta} />
        </Container>
      </Splide>
    </div>
  )
}